import type { Observable } from 'rxjs';
import { fromEvent } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

/**
 * Creates an observable that tracks a media query.
 *
 * This can be used directly with async pipe in templates or
 * with toSignal() in components to convert to a signal.
 *
 * @example
 * // In component with async pipe
 * isMobile$ = media$('(max-width: 767px)');
 *
 * // With toSignal (in injection context)
 * isMobile = toSignal(media$('(max-width: 767px)'), { initialValue: false });
 *
 * @param query CSS media query string
 * @returns Observable that emits true when the media query matches, false otherwise
 */
export const media$ = (query: string): Observable<boolean> => {
  const mediaQuery = window.matchMedia(query);
  return fromEvent<MediaQueryList>(mediaQuery, 'change').pipe(
    startWith(mediaQuery),
    map((list: MediaQueryList) => list.matches),
  );
};
